export const DATE_FORMAT_FULL_YEAR = 'DD/MM/YYYY';
export const TIME_FORMAT_MM = 'HH:mm';
export const DATE_FORMAT_SS = `${DATE_FORMAT_FULL_YEAR} ${TIME_FORMAT_MM}:ss`;
export const DATE_FORMAT_MS = 'DD/MM/YYYY HH:mm:ss.SSS';
export const DATE_FORMAT_CALL = `${TIME_FORMAT_MM}, ${DATE_FORMAT_FULL_YEAR}`;
export const DATE_FORMAT_MM = `${DATE_FORMAT_FULL_YEAR} ${TIME_FORMAT_MM}`;
